//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FreeCurationsButtons',
  props: {
    value: {
      type: String,
    },
    curations: {
      type: Array,
      required: true,
    },
  },
  computed: {
    currentCuration: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
